// extracted by mini-css-extract-plugin
export default {"main":"OrdersHistory_main__oBZkv","title":"OrdersHistory_title__OxxGV","content":"OrdersHistory_content__7dFw4","empty":"OrdersHistory_empty__QdrnU"};